<template>
  <label
    for="input-checkbox"
    class="checkbox-toggle"
    :class="{ disabled: isDisabled }"
  >
    <slot name="prepend" />
    <span>{{ disabledText || labelText }}</span>
    <input
      id="input-checkbox"
      v-model="checked"
      type="checkbox"
    />
    <slot name="append" />
  </label>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  checkedLabel: {
    type: String,
    default: '',
  },
  uncheckedLabel: {
    type: String,
    default: '',
  },
  checkedColor: {
    type: String,
    required: true,
  },
  uncheckedColor: {
    type: String,
    required: true,
  },
  useDisabledLabel: {
    type: Boolean,
    default: false,
  },
  disabledLabel: {
    type: String,
    default: '',
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:model-value']);

const checked = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:model-value', value),
});

const labelText = computed(() => (checked.value ? props.checkedLabel : props.uncheckedLabel));

const disabledText = computed(() => (props.useDisabledLabel && props.disabledLabel ? props.disabledLabel : ''));

const toggleBackgroundColor = computed(() => (
  checked.value ? props.checkedColor : props.uncheckedColor));
</script>

<style lang="less" scoped>
.checkbox-toggle {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: v-bind(toggleBackgroundColor);
  border: 1px solid @stroke-default;
  padding: 7px;
  border-radius: 8px;
  gap: 2px;

  &.disabled {
    pointer-events: none;
    filter: opacity(0.5);
  }

  &:hover {
    cursor: pointer;
  }

  span {
    font-size: 13px;
    font-weight: 500;
    color: @text-darkest;
  }

  input {
    visibility: hidden;
    width: 0;
  }

  :deep(.v-icon) path {
    fill: @icon-default;
  }
}
</style>
